export default "__VITE_ASSET__2G0OgGkw__"